<template>
  <v-container class="pt-6 pb-0">
    <!-- nombre -->
    <v-row class="pb-4">
      <v-text-field
        :label="t.auth.nombre"
        counter="35"
        v-model="datosPersonales.nombre"
        :rules="[rules.required, rules.counter]"
        required
      ></v-text-field>
    </v-row>
    <!-- cumpleanios -->
    <v-row>
      <v-menu
        v-model="showCumple"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="300px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="datosPersonales.fCumple"
            :label="t.perfil.fNac + ' - ' + t.perfil.opcional"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          ref="fCumple"
          v-model="datosPersonales.fCumple"
          :max="fechaMaxima"
          min="1910-01-01"
          full-width
          @input="showCumple = false"
        ></v-date-picker>
      </v-menu>
    </v-row>
    <!-- sexo -->
    <v-row>
      <v-radio-group
        :label="t.perfil.sexo"
        :hint="t.perfil.opcional"
        persistent-hint
        v-model="datosPersonales.sexo"
        row
      >
        <v-radio
          :label="t.perfil.hombre"
          on-icon="radio_button_checked"
          off-icon="radio_button_unchecked"
          value="h"
        ></v-radio>
        <v-radio
          :label="t.perfil.mujer"
          on-icon="radio_button_checked"
          off-icon="radio_button_unchecked"
          value="m"
        ></v-radio>
      </v-radio-group>
    </v-row>
    <!-- jerarquia -->
    <v-row class="pt-4">
      <v-select
        v-model="datosPersonales.jerq"
        :label="t.perfil.orden + ' - ' + t.perfil.opcional"
        append-icon="arrow_drop_down"
        :items="t.orden"
        item-value="cod"
        item-text="name"
      ></v-select>
    </v-row>
  </v-container>
</template>

<script>
import infoo from "../../plugins/infoo";

export default {
  name: "user-datos-personales",
  props: ["datosPersonales"],
  data() {
    return {
      showCumple: false
    };
  },
  computed: {
    fechaMaxima() {
      return infoo.hoy.iso;
    },
    rules() {
      return {
        required: value => !!value || this.t.validacion.noVacio,
        counter: value => value.length <= 35 || this.t.validacion.superaMax
      };
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  },
  watch: {
    showCumple(val) {
      val && setTimeout(() => (this.$refs.fCumple.activePicker = "YEAR"));
    }
  }
};
</script>
